/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, Suspense, useEffect } from 'react';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Tooltip
} from '@material-ui/core';
import axios from 'axios';

import Button from 'components/Button/button';
import HistoryTime from 'images/icons/combinations/historyTimeWithBg.svg';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import { Container, GlobalStyle } from 'styles/general';
import Environment from 'utils/environments';

import PurchaseHistoryProduct from '../PurchaseHistoryProduct';
import { HeaderCell, Cell, OrderCellInput, Input, Footer, IconDownload } from '../style';

const environments = Environment(process.env.REACT_APP_ENV);

const TheoryStockDialog = React.lazy(() =>
  import('components/Dialogs/ExtractsDialog')
);

const DurationDialog = React.lazy(() =>
  import('components/Dialogs/DurationDialog')
);

function PurchaseProjection({
  open,
  onClose,
  product,
  orderQuantities,
  handleOrderChange,
  onSave,
  updateProductOrderQuantities
}) {
  const [isTheoryStockOpen, setIsTheoryStockOpen] = useState(false);
  const [theoryStockProduct, setTheoryStockProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [rawValues, setRawValues] = useState({});
  const [focusedInput, setFocusedInput] = useState(null);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [historyModalData, setHistoryModalData] = useState([]);
  const [historyModalProductDesc, setHistoryModalProductDesc] = useState('');
  const [restaurantsWithHistory, setRestaurantsWithHistory] = useState([]);

  useEffect(() => {
    const fetchHistoryData = async () => {
      if (!product) return;

      const restaurantIdsWithHistory = [];

      await Promise.all(
        product.consume?.restaurants.map(async (restaurant) => {
          try {
            const response = await axios.get(
              `${environments.catalog}/shopping/orders/history?productId=${restaurant.productId}`
            );

            if (response.data && response.data.length > 0) {
              restaurantIdsWithHistory.push(restaurant.restaurantId);
            }
          } catch (err) {
            console.error(
              `Erro ao buscar histórico do restaurante ${restaurant.restaurantId}:`,
              err
            );
          }
        }) || []
      );

      setRestaurantsWithHistory(restaurantIdsWithHistory);
    };

    fetchHistoryData();
  }, [product]);

  const [modalStates, setModalStates] = useState({ modalDuration: false });
  const [durationData, setDurationData] = useState({
    product: {},
    data: {},
    type: '',
    newDuration: false
  });
  const [durationDialogLoading, setDurationDialogLoading] = useState(false);

  if (!product) return null;

  const totalStock = product?.stock?.total ?? 0;
  const totalProjection = product?.projection?.total ?? 0;
  const totalConsume = product?.consume?.total ?? 0;

  const stockTypeMap = {
    REAL: 'real',
    THEORETICAL: 'teórico'
  };

  const openTheoryStockDialog = (selectProduct, restaurant) => {
    setTheoryStockProduct({
      id: restaurant?.productId,
      description: selectProduct?.description,
      restaurantId: [restaurant?.restaurantId],
      consumptionUnitsPrimary: selectProduct?.units
    });
    setIsTheoryStockOpen(true);
  };

  const handleOpenDurationDialog = async (selectProduct, restaurant) => {
    try {
      setSelectedProduct(selectProduct);
      setDurationDialogLoading(true);

      const productId = restaurant?.productId;
      const restaurantId = restaurant?.restaurantId;

      const stock =
        product?.stock?.restaurants?.find(
          (r) => r.restaurantId === restaurantId
        )?.quantity ?? 0;

      const response = await axios.get(
        `${environments.engine}/rupture?productId=${productId}&restaurantId=${restaurantId}&days=8&stock=${stock}`
      );
      const ruptureData = response.data;
      console.log('ruptureData', ruptureData);
      setDurationData({
        product: {
          ...product,
          consumptionUnits: product?.units
        },
        data: ruptureData,
        type: 'duration',
        newDuration: false
      });

      setModalStates((prev) => ({ ...prev, modalDuration: true }));
    } catch (error) {
      console.error('Erro ao carregar dados de duração:', error);
    } finally {
      setDurationDialogLoading(false);
    }
  };

  const handleCloseDurationModal = () => {
    setModalStates({ modalDuration: false });
  };

  const formatNumber = (value) =>
    Number(value).toLocaleString('pt-BR', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    });

  const parseNumber = (value) => {
    if (!value) return 0;
    const cleaned = value.replace(/\./g, '').replace(',', '.');
    return parseFloat(cleaned);
  };

  const formatRawValue = (value) => {
    return Number(value).toFixed(3).replace('.', ',');
  };

  const totalOrder = product?.consume?.restaurants?.reduce(
    (acc, restaurant) => {
      const id = restaurant.restaurantId;
      const value =
        focusedInput === id
          ? parseNumber(rawValues[id] ?? '')
          : orderQuantities[id] ??
            product?.order?.restaurants?.find((o) => o.restaurantId === id)
              ?.quantity ??
            0;

      const num = Number(value);
      return acc + (isNaN(num) ? 0 : num);
    },
    0
  );

  return (
    <>
      <GlobalStyle />
      <Container>
        <Dialog
          open={open}
          fullScreen={false}
          onClose={onClose}
          className="defaultModal productTableDialog"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              width: '817px',
              maxHeight: '600px',
              borderRadius: '8px'
            }
          }}
        >
          <DialogTitle className="modalHeader bold textAlignCenter cursorMove">
            <Typography>
              <b>PRODUTO:</b>
              <span style={{ fontWeight: '400' }}>
                {' '}
                {product?.description?.toUpperCase() || ''}
              </span>
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <img style={{ width: '12px' }} src={CloseIconNavy} alt="Close" />
            </IconButton>
          </DialogTitle>

          <DialogContent className="modalContent onlyTableProducts pb0 pt0">
            <table
              className="purchaseTable"
              cellPadding="0"
              cellSpacing="0"
              border="0"
              style={{ marginBottom: '20px' }}
            >
              <thead>
                <tr>
                  <HeaderCell className="left col-store">
                    <span>LOJA</span>
                  </HeaderCell>
                  <HeaderCell className="right borderLGray p12 col-last7days">
                    <span>ÚLTIMOS 7 DIAS</span>
                  </HeaderCell>
                  <HeaderCell className="pr0 borderLGray col-stocktype">
                    &nbsp;
                  </HeaderCell>
                  <HeaderCell className="right p12 col-stock">
                    <span>ESTOQUE ATUAL</span>
                  </HeaderCell>
                  <HeaderCell className="right borderLGray col-duration p12">
                    <span>DURAÇÃO</span>
                  </HeaderCell>
                  <HeaderCell className="center col-projection">
                    <span>PROJEÇÃO</span>
                  </HeaderCell>
                  <HeaderCell className="subtitle center col-order">
                    <span>PEDIDO</span>
                  </HeaderCell>
                </tr>
              </thead>

              <tbody>
                {product?.consume?.restaurants?.map((restaurant, idx) => {
                  const stock = product.stock?.restaurants?.find(
                    (r) => r.restaurantId === restaurant.restaurantId
                  );
                  const duration = product.duration?.restaurants?.find(
                    (r) => r.restaurantId === restaurant.restaurantId
                  );
                  const projection = product.projection?.restaurants?.find(
                    (r) => r.restaurantId === restaurant.restaurantId
                  );
                  const order = product.order?.restaurants?.find(
                    (r) => r.restaurantId === restaurant.restaurantId
                  );

                  return (
                    <tr
                      key={restaurant.restaurantId}
                      style={{ borderBottom: '1px solid #D2D3D7' }}
                    >
                      <Cell className="description left p12 col-store">
                        <Tooltip
                          title={restaurant.companyName}
                          arrow
                          placement="top"
                        >
                          <span className="customColor">
                            {restaurant.companyName}
                          </span>
                        </Tooltip>
                      </Cell>
                      <Cell
                        className="description right borderLGray p12"
                        style={{
                          color:
                            (restaurant.quantity ?? 0) === 0
                              ? '#9296AC'
                              : '#010311'
                        }}
                      >
                        <span>
                          {(restaurant.quantity ?? 0).toLocaleString('pt-BR', {
                            minimumFractionDigits: 3
                          })}{' '}
                          {product.units?.abbreviation}
                        </span>
                      </Cell>

                      <Cell
                        className="description center borderLGray p12"
                        style={{
                          color: stock?.type === 'REAL' ? '#010311' : '#9296AC'
                        }}
                      >
                        <span>{stockTypeMap[stock?.type] || '—'}</span>
                      </Cell>

                      <Cell
                        className="description right borderLGray p12 col-stock cursorPointer"
                        onClick={() =>
                          openTheoryStockDialog(product, restaurant)
                        }
                      >
                        <span>
                          {(stock?.quantity ?? 0).toLocaleString('pt-BR', {
                            minimumFractionDigits: 3
                          })}{' '}
                          {product.units?.abbreviation}
                        </span>
                      </Cell>

                      <Cell
                        className="description right borderLGray p12 cursorPointer"
                        onClick={() =>
                          handleOpenDurationDialog(product, restaurant)
                        }
                        style={{
                          color:
                            duration?.quantity === 0 ? '#D93030' : '#5062F0'
                        }}
                      >
                        <span>
                          {duration?.quantity ?? 0}{' '}
                          {duration?.quantity === 1 ? 'dia' : 'dias'}
                        </span>
                      </Cell>

                      <Cell
                        className="description right borderLGray p12 col-projection"
                        style={{
                          color:
                            (projection?.quantity ?? 0) === 0
                              ? '#9296AC'
                              : '#010311',
                          fontWeight:
                            (projection?.quantity ?? 0) === 0 ? '400' : '700'
                        }}
                      >
                        <span>
                          {(projection?.quantity ?? 0).toLocaleString('pt-BR', {
                            minimumFractionDigits: 3
                          })}{' '}
                          {product.units?.abbreviation}
                        </span>
                      </Cell>

                      <OrderCellInput>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                            // paddingTop: '1px',
                            // paddingBottom: '1px'
                          }}
                        >
                          <Input
                            type="text"
                            value={
                              focusedInput === restaurant.restaurantId
                                ? rawValues[restaurant.restaurantId] ?? ''
                                : formatNumber(
                                    orderQuantities[restaurant.restaurantId] ??
                                      order?.quantity ??
                                      0
                                  )
                            }
                            onFocus={(e) => {
                              const current =
                                orderQuantities[restaurant.restaurantId] ??
                                order?.quantity ??
                                0;
                              setFocusedInput(restaurant.restaurantId);
                              setRawValues((prev) => ({
                                ...prev,
                                [restaurant.restaurantId]:
                                  formatRawValue(current)
                              }));

                              setTimeout(() => {
                                e.target.select();
                              }, 0);
                            }}
                            onChange={(e) => {
                              let newValue = e.target.value;

                              newValue = newValue.replace(/[^\d,]/g, '');

                              const parts = newValue.split(',');
                              if (parts.length > 2) {
                                newValue = `${parts[0]},${parts
                                  .slice(1)
                                  .join('')}`;
                              }

                              const currentRaw =
                                rawValues[restaurant.restaurantId];
                              if (
                                (currentRaw === '0,000' || currentRaw === '') &&
                                newValue.length === 1
                              ) {
                                newValue = newValue;
                              }

                              setRawValues((prev) => ({
                                ...prev,
                                [restaurant.restaurantId]: newValue
                              }));
                            }}
                            onBlur={() => {
                              const raw =
                                rawValues[restaurant.restaurantId] ?? '';
                              const parsed = parseNumber(raw);
                              handleOrderChange(
                                restaurant.restaurantId,
                                parsed
                              );
                              setFocusedInput(null);
                            }}
                          />
                          <span
                            style={{
                              fontSize: '12px',
                              color: '#010311',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {product.units?.abbreviation}
                          </span>
                          {restaurantsWithHistory.includes(
                            restaurant.restaurantId
                          ) && (
                            <Tooltip
                              title={
                                <>
                                  Pedidos registrados
                                  <br />
                                  nos últimos 90 dias
                                </>
                              }
                              placement="bottom-right"
                            >
                              <IconButton
                                style={{ padding: '2px', marginLeft: '4px', paddingRight: '0px'}}
                                onClick={async () => {
                                  try {
                                    const productId = restaurant.productId;
                                    const response = await axios.get(
                                      `${environments.catalog}/shopping/orders/history?productId=${productId}`
                                    );

                                    const formattedData = response.data.map(
                                      (item) => {
                                        const [year, month, day] =
                                          item.date.split('-');

                                        return {
                                          date: `${day}/${month}/${year}`,
                                          quantity:
                                            item.quantity.toLocaleString(
                                              'pt-BR',
                                              {
                                                minimumFractionDigits: 3
                                              }
                                            )
                                        };
                                      }
                                    );

                                    setHistoryModalProductDesc(
                                      product.description
                                    );
                                    setHistoryModalData(formattedData);
                                    setIsHistoryModalOpen(true);
                                  } catch (error) {
                                    console.error(
                                      'Erro ao buscar histórico do produto:',
                                      error
                                    );
                                  }
                                }}
                              >
                                <img
                                  src={HistoryTime}
                                  alt="Histórico"
                                  style={{ width: '16px', height: '16px' }}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      </OrderCellInput>
                    </tr>
                  );
                })}

                <Footer>
                  <Cell className="subtitle bold p12">
                    <span className="slateText">TOTAL</span>
                  </Cell>
                  <Cell className="subtitle right p12 bold">
                    <span className="slateText">
                      {totalConsume.toLocaleString('pt-BR', {
                        minimumFractionDigits: 3
                      })}{' '}
                      {product.units?.abbreviation}
                    </span>
                  </Cell>

                  <td className="subtitle center">&nbsp;</td>

                  <Cell className="subtitle right bold p12">
                    <span className="slateText">
                      {totalStock.toLocaleString('pt-BR', {
                        minimumFractionDigits: 3
                      })}{' '}
                      {product.units?.abbreviation}
                    </span>
                  </Cell>

                  <td className="subtitle center">&nbsp;</td>

                  <Cell className="subtitle right borderLGray bold p12 col-projection">
                    <span className="blackText">
                      {totalProjection.toLocaleString('pt-BR', {
                        minimumFractionDigits: 3
                      })}{' '}
                      {product.units?.abbreviation}
                    </span>
                  </Cell>
                  <Cell className="subtitle right bold pl16">
                    <span className="blackText">
                      {totalOrder.toLocaleString('pt-BR', {
                        minimumFractionDigits: 3
                      })}{' '}
                      {product.units?.abbreviation}
                    </span>
                  </Cell>
                </Footer>
              </tbody>
            </table>
          </DialogContent>
          <div className="dFlex justifyEnd p12 pb12 pt12">
            <Button
              variant="contained"
              design="contained"
              label="Salvar"
              className="defaultButton submitButton"
              onClick={async () => {
                await onSave();

                const updatedRestaurants = product.consume.restaurants.map(
                  (restaurant) => {
                    const restaurantId = restaurant.restaurantId;
                    const quantity = orderQuantities[restaurantId] ?? 0;

                    return {
                      restaurantId,
                      quantity,
                      productId: restaurant.productId
                    };
                  }
                );
                updateProductOrderQuantities?.(product.id, updatedRestaurants);
              }}
            />
          </div>
        </Dialog>
        <Suspense fallback={<div />}>
          {isTheoryStockOpen && theoryStockProduct && (
            <TheoryStockDialog
              openModal={{ modalProduct: true }}
              handleClose={() => setIsTheoryStockOpen(false)}
              getId={theoryStockProduct.restaurantId}
              checkConsume={false}
              setCheckConsume={() => {}}
              productExtractDescription={theoryStockProduct.description}
              productModal={theoryStockProduct}
              setProductModal={setTheoryStockProduct}
              parameters=""
              originPage="purchaseProjection"
            />
          )}
        </Suspense>

        <Suspense fallback={<span />}>
          <DurationDialog
            openModal={modalStates}
            handleClose={handleCloseDurationModal}
            durationData={durationData}
            loading={durationDialogLoading}
            page="PurchaseProjection"
            selectedProduct={selectedProduct}
            setDurationData={setDurationData}
          />
        </Suspense>

        <PurchaseHistoryProduct
          open={isHistoryModalOpen}
          onClose={() => setIsHistoryModalOpen(false)}
          productDescription={historyModalProductDesc}
          data={historyModalData}
        />
      </Container>
    </>
  );
}

export default PurchaseProjection;
